import React from 'react';

import {PressableContainer, ViewContainer} from './styles';

interface Props {
  gap?: number;
  alignItems?: 'center' | 'flex-start' | 'flex-end';
  justifyContent?:
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around';
  flexWrap?: 'wrap' | 'nowrap' | 'wrap-reverse';
  backgroundColor?: string;
  children?: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
}

const Row: React.FC<Props> = ({children, onClick, ...props}) => {
  if (onClick)
    return (
      <PressableContainer {...{...props, onClick}}>
        {children}
      </PressableContainer>
    );
  return <ViewContainer {...props}>{children}</ViewContainer>;
};

export default Row;
